/**
 * Blocking query
 */
const MAX_QUERIES = 4;
const SLEEP_TIME = 20;

class BackendQueryRunner {
    constructor() {
        this.runningQueries = new Set();
    }

    submit(queryJson) {
        return new Promise(async (resolve, reject) => {
            while (this.runningQueries.size >= MAX_QUERIES) {
                await this.sleep(SLEEP_TIME);
            }

            this.runningQueries.add(queryJson);

            let url = "/search";
            if (window.spores) {
                url = "https://zequencer.io" + url;
            }
            fetch(url , {
                method: 'POST',
                body: JSON.stringify(queryJson),
                
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
                .then(resp => resp.json())
                .then(resp => {
                    this.removeQuery(queryJson);
                    resolve(resp || []);
                })
                .catch(err => {
                    console.log(err);
                    this.removeQuery(queryJson);
                });
        });
    }

    removeQuery(queryJson) {
        this.runningQueries.delete(queryJson);
    }

    sleep(time) {
        return new Promise((resolve, reject) => {
            setTimeout(resolve, time);
        });
    }
}

export default BackendQueryRunner;
